module.exports.common = {
  apiUrl: 'https://api.instadispatch.com/live/restservices/',
  socketUrl: 'wss://gps.app-tree.co.uk:3500',
  chat_url: 'https://chat.instadispatch.com:4006',
 base_url: 'https://devdispatcher.instadispatch.com/api/bagging',
}